import React, { useState, useEffect } from "react";
import { Checkbox } from "primereact/checkbox";
import { RadioButton } from "primereact/radiobutton";
import { useTranslation } from "react-i18next";
import ArrowDown from "../../../../assets/svg/arrow-down.svg";
import ArrowUp from "../../../../assets/svg/arrow-up.svg";
import TopPick from "../../../../assets/AnimatedEmojies.gif";
import "./styles.css";

const CoverageAccordion = ({
  index,
  name,
  extended,
  type = "radio",
  position,
  subFeatures,
  topPicked,
  initialFeatrues,
  handleChange,
}) => {
  const [showContent, setShowContent] = useState(true);
  const [total, setTotal] = useState(0);
  const [selectedList, setSelectedList] = useState([]);
  const [selectedPricesList, setSelectedPricesList] = useState([]);
  const { t } = useTranslation();

  const handleFeatureSelect = (feature, checked) => {
    const code = feature.featurecode;
    const price = +feature.priceDetails.priceDetailsArray[0].priceValue;
    if (type === "radio") {
      setSelectedList([checked ? null : code]);
      setSelectedPricesList([checked ? null : price]);
      handleChange(index, [checked ? null : code]);
      updatePrice([checked ? null : price]);
    } else {
      if (checked) {
        let selectedListCopy = [...selectedList];
        let selectedPricesListCopy = [...selectedPricesList];

        const checkedIndex = selectedListCopy.findIndex(
          (item) => item === feature.featurecode
        );

        selectedListCopy.splice(checkedIndex, 1);
        selectedPricesListCopy.splice(checkedIndex, 1);

        setSelectedList(selectedListCopy);
        setSelectedPricesList(selectedPricesListCopy);
        handleChange(index, selectedListCopy);
        updatePrice(selectedPricesListCopy);
        return;
      }
      let selectedListCopy = [...selectedList, code];
      let selectedPricesListCopy = [...selectedPricesList, price];
      setSelectedList(selectedListCopy);
      setSelectedPricesList(selectedPricesListCopy);
      handleChange(index, selectedListCopy);
      updatePrice(selectedPricesListCopy);
    }
  };

  const updatePrice = (list) => {
    let total = 0;
    list.map((elm) => (total += +elm));
    setTotal(total);
  };

  useEffect(() => {
    if (initialFeatrues.length > 0) {
      let featureCodeList = [];
      let priceList = [];
      initialFeatrues.map((feature) => {
        const existFeature = subFeatures.find(
          (item) => item.featurecode === feature.featureCode
        );
        if (existFeature) {
          featureCodeList.push(existFeature.featurecode);
          priceList.push(
            +existFeature.priceDetails.priceDetailsArray[0].priceValue
          );
        }
      });

      setSelectedList(featureCodeList);
      setSelectedPricesList(priceList);
      updatePrice(priceList);
    }
  }, []);

  return (
    <div className="coverage_accordion_container_layout">
      <div
        className={`normal_renew_coverage ${
          position === "first"
            ? "first"
            : position === "last" && !showContent
            ? "last"
            : null
        }`}
        onClick={() => setShowContent(!showContent)}
      >
        <div className="title_price_container">
          <span>{name}</span>
          <div className="price_container">
            <span className="price_style">{total}</span>
            <span className="price_sar_sub">{"SAR"}</span>
          </div>
        </div>
        <div className="toggle_button_container">
          {topPicked && (
            <div className="top_pick">
              <img style={{ width: 24, height: 24 }} src={TopPick} alt="" />
              <span className="text">{t("top_pick")}</span>
            </div>
          )}
          <div className="toggle_Button">
            {showContent ? (
              <img src={ArrowUp} alt="" />
            ) : (
              <img src={ArrowDown} alt="" />
            )}
          </div>
        </div>
      </div>

      {showContent && (
        <div className="body">
          {subFeatures.map((feature, idx) => {
            const checked = selectedList.some(
              (item) => feature.featurecode === item
            );
            return (
              <div
                key={idx}
                className="item"
                onClick={() => handleFeatureSelect(feature, checked)}
              >
                <div className="title_container">
                  {type === "radio" ? (
                    <div className="radio">
                      <div
                        className={checked ? "inside_checked" : "inside"}
                      ></div>
                    </div>
                  ) : (
                    <Checkbox onChange={() => {}} checked={checked} />
                  )}

                  <span className="title">{feature.featureDescription}</span>
                </div>
                <div className="price_container">
                  <span className="price_sub">{t("total_premium")}</span>
                  <span className="price_style">{`${feature.priceDetails.priceDetailsArray[0].priceValue} SAR`}</span>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default CoverageAccordion;
